import { render, staticRenderFns } from "./CustomersList.vue?vue&type=template&id=09d0599e&scoped=true&"
import script from "./CustomersList.vue?vue&type=script&lang=js&"
export * from "./CustomersList.vue?vue&type=script&lang=js&"
import style0 from "./CustomersList.vue?vue&type=style&index=0&id=09d0599e&prod&lang=scss&"
import style1 from "./CustomersList.vue?vue&type=style&index=1&id=09d0599e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d0599e",
  null
  
)

export default component.exports